// extracted by mini-css-extract-plugin
export default {"root":"StateLicenseListItem_root__MFbpk","licenseIcon":"StateLicenseListItem_licenseIcon__RItFs"};